import { Group, Tooltip, Box } from '@mantine/core';
import PricingPlanFeature from 'src/entities/pricing/pricingPlanFeature';
import Workspace from 'src/entities/workspace';
import Text from '@ui/components/Text/Text';
import InformationIcon from '@ui/components/InformationIcon/InformationIcon';
import Badge, { BADGE_LIGHT_STYLES } from '../Badge/Badge';
import FeaturePaywall, { FeaturePaywallRenderParams } from '../../../workspaces/components/FeaturePaywall/FeaturePaywall';

type LabelWithInformationProps = {
	text: string;
	tooltipText: string;
	required?: boolean;
	feature?: PricingPlanFeature;
	selectedWorkspace?: Workspace | null;
	origin?: string;
};

const LabelWithInformation = ( {
	text,
	tooltipText,
	required = false,
	feature,
	selectedWorkspace,
	origin
}: LabelWithInformationProps ) => {
	const textGroup = (
		<Group spacing={4} style={{ flexShrink: 0 }}>
			<Text variant="body-bold">{text}</Text>
			{required && <span style={{ color: 'red' }}>*</span>}
			{feature && selectedWorkspace && (
				<FeaturePaywall feature={feature} workspace={selectedWorkspace} origin={origin}>
					{( {
						planName,
						paywallMessage,
						isFeatureAvailable
					}: FeaturePaywallRenderParams ) => (
						!isFeatureAvailable && (
							<Tooltip
								label={<div style={{ whiteSpace: 'pre-line', textAlign: 'center', fontSize: '12px' }}>{paywallMessage}</div>}
								withArrow
								position="top"
								offset={4}
								withinPortal
								arrowPosition="center"
								color="space.9"
							>
								<Badge color="green" size="xs" variant="light" styles={BADGE_LIGHT_STYLES}>
									{`${planName}`}
								</Badge>
							</Tooltip>
						)
					)}
				</FeaturePaywall>
			)}
		</Group>
	);

	const informationIcon = <InformationIcon text={tooltipText} color="dark" />;

	return (
		<Box style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
			{textGroup}
			{informationIcon}
		</Box>
	);
};

export default LabelWithInformation;
